import BasketIcon from "./BasketIcon.js";
import BasketIconHandler from "./BasketIconHandler.js";
import BasketHandler from "./BasketHandler.js";
import initDiscounts from "./initDiscounts.js";

const initBasket = () => new BasketHandler();

export {
    initBasket as default,
    BasketHandler,
    BasketIcon,
    BasketIconHandler,
    initDiscounts
}
